import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
import { toggleAssessmentModal } from '../../../redux/actions/assessmentsActions';
export const assessmentDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.methodologySection',
        popover: {
          title: 'Assessment Methodology',
          description:
            'This section explains the methodology used for assessments. Understanding the methodology will help you interpret the results accurately.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.createAssessmentSection',
        popover: {
          title: 'Create New Assessment',
          description:
            'Click here to start creating a new assessment. You can define parameters, criteria, and other details for the assessment.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.assessmentSection',
        popover: {
          title: 'Assessment Overview',
          description:
            'This section provides an overview of the current assessment. Review the key metrics and findings here.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.rankSection',
        popover: {
          title: 'Rank Assessments',
          description:
            'Rank the assessments based on predefined criteria. This helps in prioritizing and focusing on the most critical areas.',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.allAssessments',
        popover: {
          title: 'All Assessments',
          description:
            'View a list of all assessments conducted. You can filter, sort, and review past assessments here.',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.unCompletedAssessments',
        popover: {
          title: 'Incomplete Assessments',
          description:
            'These are assessments that have not been completed yet. You can resume and complete them from this section.',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.completedAssessment',
        popover: {
          title: 'Completed Assessments',
          description:
            'This section contains assessments that have been completed. You can review and analyze the results here.',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.assessmentMainTable',
        popover: {
          title: 'Assessment Data Table',
          description:
            'This table provides detailed data for all assessments. Use it to dive deep into the specifics of each assessment.',
          side: 'top',
          align: 'end',
          onNextClick: () => {
            // dispatch(toggleAssessmentModal())
            driverObj.destroy();
          },
        },
      },
    ],
  });
  return driverObj;
};
export default assessmentDriverObj;
